import { PARK_TICKET, PARK_TICKET_SUCCESS, PARK_TICKET_ERROR, PARK_TICKET_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ParkTicket = (state = initialState, action) => {
  switch (action.type) {
    case PARK_TICKET:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case PARK_TICKET_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case PARK_TICKET_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case PARK_TICKET_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ParkTicket;
